<template>
  <div class="pages">
    <router-view v-if="!isLoadingCover" :isAssigneeView="isAssigneeView"/>

    <new-class-preview-pages-pagination :pagination="pagination"/>

    <cat-loading-cover v-if="isLoadingCover" :isCat="false"/>
  </div>
</template>

<script>
import { NEWCLASS_BASE_URL } from '@/config';
import { PageType } from '@/app/viewer-newclass-pages/components/NewClassPagesPagination';

import { mapActions, mapGetters } from 'vuex';
import { isEmpty } from 'lodash';
import NewClassPreviewPagesPagination from '../components/NewClassPreviewPagesPagination';
import CatLoadingCover from '../../viewer-cat-pages/components/CatLoadingCover';

export default {
  name: 'new-class-preview-pages-index',

  props: ['cardId', 'cardType'],

  components: {
    NewClassPreviewPagesPagination,
    CatLoadingCover,
  },

  data() {
    return {
      isLoadingCover: true,
      isAssigneeView: false,
    };
  },

  computed: {
    ...mapGetters({
      card: 'getCardForNewClass',
      pageList: 'getPageListForNewClass',
      routeParams: 'getRouteParams',
      pagination: 'getPagesPaginationForNewClass',
      currentPage: 'getCurrentPageForNewClass',
    }),
  },

  methods: {
    ...mapActions({
      fetchCard: 'fetchCardForNewClass',
      fetchPagesPagination: 'fetchPagesPaginationForNewClass',
      fetchPagesForNewClass: 'fetchPagesForNewClass',
      setCurrentPage: 'setCurrentPageForNewClass',
      setAllPagesResult: 'setAllPagesResultForNewClass',
      saveQuizOption: 'saveQuizOptionForNewClass',
      saveQuizValue: 'saveQuizValueForNewClass',
      saveGradingStatus: 'saveGradingStatusForNewClass',
    }),

    // TODO: 중복되는 코드 리팩터링 필요
    saveAssigneePreviewResults(results) {
      this.setAllPagesResult(results);

      const resultsEntries = Object.entries(results);
      resultsEntries.forEach((resultEntry) => {
        const quizId = resultEntry[0];
        const result = resultEntry[1];

        if (result.pageType === PageType.essay_type) {
          this.saveQuizValue({ quizId, value: result.essay });
        }

        if (result.pageType === PageType.text_entry) {
          this.saveQuizValue({ quizId, value: result.textEntry });
        }

        if (result.pageType === PageType.multiple_choice) {
          this.saveQuizOption({
            quizId,
            option: result.multipleChoiceOption,
            index: result.multipleChoiceOption.optionIndex,
          });
        }
      });
    },

    handlePreviewPostMessage(event) {
      let payload;
      try {
        payload = JSON.parse(event.data);
      } catch (error) {
        return;
      }
      if (
        event.origin === NEWCLASS_BASE_URL &&
        payload.method === 'learningAssigneeAnswers'
      ) {
        const results = payload.data.assigneeAnswers;
        const isGraded = payload.data.isGraded;

        this.saveAssigneePreviewResults(results);
        this.saveGradingStatus(isGraded);
        this.isAssigneeView = true;
      }
    },
  },

  created() {
    window.addEventListener('message', this.handlePreviewPostMessage);
  },

  beforeMount() {
    Promise.resolve()
      .then(() => {
        if (isEmpty(this.card)) {
          const cardId = this.cardId;
          const cardType = this.cardType;
          return this.fetchCard({ cardId, cardType });
        }
        return true;
      })
      .then(() => {
        this.fetchPagesPagination({
          total: this.card.pages.length,
          page: this.routeParams.page,
        });
      })
      .then(() => {
        const message = JSON.stringify({
          method: 'loadAssigneeAnswers',
          callback: 'learningAssigneeAnswers',
        });
        window.parent.postMessage(message, NEWCLASS_BASE_URL);
      })
      .then(() => {
        this.isLoadingCover = false;
      });
  },

  beforeDestroy() {
    window.removeEventListener('message', this.handlePreviewPostMessage);
  },

  watch: {
    pageList() {
      this.setCurrentPage(this.routeParams.page - 1);
    },
    $route() {
      Promise.resolve()
        .then(() => {
          if (isEmpty(this.card)) {
            const cardId = this.cardId;
            const cardType = this.cardType;
            return this.fetchCard({ cardId, cardType });
          }

          return true;
        })
        .then(() => this.setCurrentPage(this.routeParams.page - 1))
        .then(() => {
          this.fetchPagesPagination({
            total: this.card.pages.length,
            page: this.routeParams.page,
          });
        })
        .then(() => {
          this.isLoadingCover = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.pages {
  user-select: none;
  background: #ffffff;
  min-height: 100%;
  overflow: auto;
}
</style>
